import { Alert, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { EquipmentDetailView } from '../components/equipment/EquipmentDetailView';

export function EquipmentDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <Alert
        message="設備が見つかりません"
        description="設備IDが指定されていません。設備一覧に戻って再度選択してください。"
        type="error"
        action={
          <Button onClick={() => navigate('/app/equipments')}>
            設備一覧へ
          </Button>
        }
      />
    );
  }

  return <EquipmentDetailView equipmentId={id} mode="page" />;
}
